import { ReactComponent as MainLogoIcon } from "./../../images/main-logo.svg";
import { ReactComponent as ArrowLeft } from "./../../images/arrow_left.svg";
import { useEffect, useState } from "react";
import { CreateAccount } from "./components/CreateAccount/CreateAccount";
import "./SelfSignUp.css";
import { VerifyNotification } from "./components/VerifyNotification/VerifyNotification";
import { useNavigate, useSearchParams } from "react-router-dom";
import TalaeraRoutes from "../../components/routes/TalaeraRoutes";
import { SignUpStatus } from "./constants";
import LanguageSelector, { LANGUAGES } from "../../components/LanguageSelector";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import useUser from "hooks/useUser";
import Button from "components/formElements/Button/Button";

const SelfSignUp = () => {
  const navigate = useNavigate();
  const user = useUser();

  const [email, setEmail] = useState("");
  const [searchParams] = useSearchParams();
  const [lang, setLang] = useState(LANGUAGES[0].value);
  const { i18n } = useTranslation();
  const isProUser = searchParams.get("is_pro") === "true";
  const uiLanguage = user?.localization_lang || navigator.language;
  const [step, setStep] = useState<SignUpStatus>(SignUpStatus.CreateAccount);
  const [resendVerificationToken, setResendVerificationToken] = useState<string>();

  useEffect(() => {
    let supportedLanguages = LANGUAGES.map(v => v.value);

    if (i18n.language !== uiLanguage) {
      let changeValue = supportedLanguages.includes(uiLanguage) ? uiLanguage : "en";
      i18n.changeLanguage(changeValue).then(() => {
        setLang(changeValue);
      });
    } else {
      setLang(uiLanguage);
    }
  }, [i18n, uiLanguage]);

  const hdSelect = (value: string) => setLang(value);
  const totalSteps = isProUser ? 6 : 5;

  const handleCreateAccount = (userEmail: string, token: string) => {
    setEmail(userEmail);
    setResendVerificationToken(token);
    setStep(SignUpStatus.VerifyNotification);
  };

  const handlePreviousStep = () => {
    if (step === SignUpStatus.VerifyNotification) {
      setStep(SignUpStatus.CreateAccount);
    } else {
      navigate(TalaeraRoutes.ROOT.path);
    }
  };

  return (
    <div>
      <Helmet htmlAttributes={{ lang: i18n.language }}>
        <title>Talaera | Sign Up</title>
        <meta
          name="description"
          content="This page is for guest to sign up as new user"
        />
      </Helmet>

      <div className="self-signup-page">
        <div className="self-signup-page-container">
          <div className="self-signup-header">
            <Button className={"previous-step"} onClick={handlePreviousStep}>
              <ArrowLeft />
            </Button>
            <MainLogoIcon className="self-signup-logo" />
            <LanguageSelector
              color={"black"}
              className={"language-btn"}
              onSelect={hdSelect}
              value={lang}
            />
          </div>

          <div className="self-signup-progress-bar">
            <div
              className="self-signup-progress-inner"
              style={{ width: `${Math.ceil((step / totalSteps) * 100)}%` }}
            />
          </div>

          <div>
            {step === SignUpStatus.CreateAccount && (
              <CreateAccount
                selectedLanguage={lang}
                isPro={isProUser}
                onCreateAccount={handleCreateAccount}
              />
            )}

            {step === SignUpStatus.VerifyNotification && resendVerificationToken && (
              <VerifyNotification email={email} token={resendVerificationToken} />
            )}
          </div>
        </div>
        <div className="filler" />
      </div>
    </div>
  );
};

export default SelfSignUp;
